// // import React from "react";

// // const ViewDocPopup = () => {
// //   return <div></div>;
// // };

// // export default ViewDocPopup;

// import React, { useState } from "react";
// import { Modal, Box, Typography, Button, IconButton } from "@mui/material";
// import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
// import CloseIcon from "@mui/icons-material/Close";
// import PDFmodal from "../components/PDFmodal";

// const ViewDocPopup = ({ isOpen, onClose, onView }) => {
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   return (
//     <Modal open={isOpen} onClose={onClose} aria-labelledby="document-popup">
//       <Box
//         sx={{
//           position: "absolute",
//           top: "50%",
//           left: "50%",
//           transform: "translate(-50%, -50%)",
//           width: "40vw",
//           bgcolor: "white",
//           boxShadow: 24,
//           p: 4,
//           borderRadius: 3,
//           textAlign: "center",
//         }}
//       >
//         {/* Close Button */}
//         <IconButton
//           sx={{ position: "absolute", top: 10, right: 10 }}
//           onClick={onClose}
//         >
//           <CloseIcon />
//         </IconButton>

//         {/* Document Icon */}
//         <Box
//           sx={{
//             width: 60,
//             height: 60,
//             borderRadius: "50%",
//             backgroundColor: "#E3F2FD",
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             margin: "auto",
//             mb: 2,
//           }}
//         >
//           <DescriptionOutlinedIcon sx={{ fontSize: 40, color: "#2196F3" }} />
//         </Box>

//         {/* Title */}
//         <Typography variant="h6" fontWeight="bold">
//           Registry Document
//         </Typography>

//         {/* Subtitle */}
//         <Typography
//           variant="body2"
//           color="text.secondary"
//           sx={{ mt: 1, mb: 2 }}
//         >
//           *Please once view the registry document carefully
//         </Typography>

//         {/* View Document Button */}
//         <Button
//           variant="contained"
//           sx={{
//             bgcolor: "#2196F3",
//             borderRadius: "20px",
//             px: 3,
//             py: 1,
//             textTransform: "none",
//             fontSize: "16px",
//           }}
//           //   onClick={onView}
//           onClick={() => setIsModalOpen(true)}
//         >
//           View Document
//         </Button>
//         <PDFmodal
//           isOpen={isModalOpen}
//           onClose={() => setIsModalOpen(false)}
//           pdfUrl={onView}
//         ></PDFmodal>
//       </Box>
//     </Modal>
//   );
// };

// export default ViewDocPopup;

// import React from "react";

// const ViewDocPopup = () => {
//   return <div></div>;
// };

// export default ViewDocPopup;

import React, { useState } from "react";
import { Modal, Box, Typography, Button, IconButton } from "@mui/material";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import CloseIcon from "@mui/icons-material/Close";
import PDFmodal from "../components/PDFmodal";

const ViewDocPopup = ({ isOpen, onClose, onView, onNext }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  return (
    <Modal open={isOpen} onClose={onClose} aria-labelledby="document-popup">
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "40vw",
          bgcolor: "white",
          boxShadow: 24,
          p: 4,
          borderRadius: 3,
          textAlign: "center",
        }}
      >
        {/* Close Button */}
        <IconButton
          sx={{ position: "absolute", top: 10, right: 10 }}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>

        {/* Document Icon */}
        <Box
          sx={{
            width: 60,
            height: 60,
            borderRadius: "50%",
            backgroundColor: "#E3F2FD",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "auto",
            mb: 2,
          }}
        >
          <DescriptionOutlinedIcon sx={{ fontSize: 40, color: "#2196F3" }} />
        </Box>

        {/* Title */}
        <Typography variant="h6" fontWeight="bold">
          Registry Document
        </Typography>

        {/* Subtitle */}
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ mt: 1, mb: 2 }}
        >
          *Please once view the registry document carefully
        </Typography>

        {/* View Document Button */}
        {onNext && (
          <Button
            variant="contained"
            sx={{
              bgcolor: "#2196F3",
              borderRadius: "20px",
              px: 3,
              py: 1,
              textTransform: "none",
              fontSize: "16px",
            }}
            //   onClick={onView}
            //  onClick={() => setIsModalOpen(true)}
            onClick={onNext}
          >
            View Document
          </Button>
        )}
        <PDFmodal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          pdfUrl={onView}
        ></PDFmodal>
      </Box>
    </Modal>
  );
};

export default ViewDocPopup;
